import axios from "axios";

const language = localStorage.getItem("language") || "en";
const nodeinstance = axios.create({
  baseURL: process.env.REACT_APP_NODE_BACKEND_URL,
  headers: {
    "Content-type": "application/json",
    "X-localization": language,
    Accept: "application/json",
  },
});

// Add auth interceptor so useServerPagination works with authenticated endpoints
nodeinstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("nodeToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

nodeinstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("nodeToken");
      window.location.replace("/login");
    }
    return Promise.reject(error);
  }
);

export default nodeinstance;